<template>
  <div>
    <router-view :config="config" :surveillance="surveillance">
    </router-view>
  </div>
</template>
<script>
export default {
  name: 'module-main',

  props: {
    config: {
      type: Object,
      required: true
    },

    surveillance: {
      type: Object
    }
  }
}
</script>
<style>
</style>
